module.exports = __webpack_public_path__ + "img/car.1fb43751.png";